import { useState } from "react"
import styles from "./product-card.module.css"
import { useAuth } from "@/components/context/AuthContext"
import { Edit2Icon } from "lucide-react";
import EditProductModal from "./EditProductModal";


export default function ProductCard({ product, onRemove, onUpdate }) {
  const { user, isAuthenticated } = useAuth();
  const [showEditModal, setShowEditModal] = useState(false)

  function getImageSrc(image) {
    if (!image) return null;
  
    // Case 1: Already a single string (URL or complete base64 src)
    if (typeof image === "string") {
      return image;
    }
  
    // Case 2: Segregated: { data: "...", contentType: "..."}
    if (image.data && image.contentType) {
      return `data:${image.contentType};base64,${image.data}`;
    }
  
    return null; // fallback
  }
  

  return (
    <>
      <div className={styles.productCard}>
        {product.badge && <div className={styles.badge}>{product.badge}</div>}
        <div className={styles.typeIndicator}>{product.type === "digital" ? "🔑 Digital" : "📦 Physical"}</div>

        <div className={styles.imageContainer}>
          <img src={getImageSrc(product.image) || "/placeholder.svg"} alt={product.name} className={styles.productImage} />
        </div>

        <div className={styles.productInfo}>
          <h3 className={styles.productName}>{product.name}</h3>
          <p className={styles.productDesc}>{product.details}</p>
          {product?.createdBy && (
            <div>
              <h4 className={styles.productDesc}>Created By:</h4>
              <p className={styles.productDesc}>{product?.createdBy.name}</p>
              <p className={styles.productDesc}>{product?.createdBy.email}</p>
            </div>
          )}

          <div className={styles.priceSection}>
            <span className={styles.price}>₹{product.price}</span>
          </div>

          {/* <div className={styles.marketplaces}>
          <p className={styles.marketplaceLabel}>Available on:</p>
          <div className={styles.marketplaceIcons}>
            {Object.entries(product.affiliateLinks || {}).map(([key, link]) => (
              <a
                key={key}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.marketplaceIcon}
                title={marketplaceInfo[key]?.name}
                style={{ backgroundColor: marketplaceInfo[key]?.color }}
              >
                {marketplaceInfo[key]?.icon}
              </a>
            ))}
          </div>
        </div> */}

          <div className={styles.actionButtons}>
            <button className={styles.buyBtn}>Buy Now</button>
            {onRemove && isAuthenticated && user?.role === "admin" && (
              <>
                <button className={styles.removeBtn} onClick={() => onRemove(product._id)}>
                  Remove
                </button>
                <button className={styles.removeBtn} onClick={() => setShowEditModal(true)}>
                  <Edit2Icon />
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {showEditModal && (
        <EditProductModal
          product={product}
          onClose={() => setShowEditModal(false)}
          onSave={async (updatedProduct) => {
            if (onUpdate) await onUpdate(updatedProduct)
          }}
        />
      )}
    </>
  )
}
